import { client } from '../http';

export default {
  async fetchBudget({ budgetDate }) {
    const response = await client.get(`/api/budget/${budgetDate}`);
    return response.data;
  },
  async fetchAllBudgets() {
    const response = await client.get('/api/budget');
    return response.data;
  },
};
